export enum OperationType {
	PAY = 0,
	REVERSE = 1,
	REFUND = 2
}
